import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Column, Columns, Typography } from "@aviary";
import FullscriptLogoSvg from "@shared/assets/logo/fullscript-logo-green-leaf-pigeon-text.svg";
import WellevateByFullscriptLogo from "@shared/assets/logo/wellevate-by-fullscript.png";
import { useBreakpoints } from "@shared/hooks";
// eslint-disable-next-line @fullscript/cross-reference
import {
  StoreLandingFooter,
  StoreLandingPageNavBar,
} from "@unauthenticated/signupSignin/components";
// eslint-disable-next-line @fullscript/cross-reference
import { l } from "@unauthenticated/wellevateAuthorize/patients/locales/i18n";

import * as styles from "./WellevateStepWrapper.styles";

interface Props {
  children: ReactNode;
  headerText: string;
  bodyText: string;
  bodySubText?: string;
}

const WellevateStepWrapper = ({ headerText, bodyText, bodySubText, children }: Props) => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();

  return (
    <div css={styles.layoutContainer}>
      <StoreLandingPageNavBar />
      <Columns isMarginless css={styles.columnsContainer}>
        {phoneLarge.greaterThan && (
          <Column columnWidth={6} css={styles.leftColumn}>
            <section css={styles.section}>
              <FullscriptLogoSvg css={styles.fsLogo} aria-label="Fullscript logo" />
              <Typography type="h5">{t(l.common.header.logoText)}</Typography>
              <img
                src={WellevateByFullscriptLogo}
                css={styles.wvLogo}
                alt={t(l.companies.Wellevate)}
              />
              <Typography type="h4">{headerText}</Typography>
              <Typography>{bodyText}</Typography>
              {bodySubText && <Typography>{bodySubText}</Typography>}
            </section>
          </Column>
        )}

        <Column columnWidth={6} css={styles.rightColumn}>
          {children}
        </Column>
      </Columns>
      <StoreLandingFooter />
    </div>
  );
};

export { WellevateStepWrapper };
